<template>
    <div
		class="rp-messenger-reply-input-box"
		
	>
        <textarea
            ref="textarea"
            @keydown.enter="handleKeyEnter"
            v-model="text"
            name="message"
            :placeholder="$t('placeholders.typeAMessage')">
        </textarea>
        <div class="rp-messenger-reply-input-utils">
			<el-popover
				placement="top"
				width="350"
				offset="125"
				trigger="click"
				v-model="isEmojisPopoverVisible">
				<div class="rp-emojis">
					<EmojisExplorer @click="handleEmojiItemClick"/>
				</div>
				<button
					class="rp-messenger-reply-input-utils-button"
					slot="reference">
					<EmojiIcon />
				</button>
			</el-popover>
			<button
				@click="handleFileUploadClick"
				v-if="!isTextActive"
				class="rp-messenger-reply-input-utils-button file-upload">
				<ClipIcon />
				<input
					ref="fileUpload"
					id="fileUpload"
					type="file"
					@change="handleFileChange"
				/>
            </button>
			<button
				@click="handleKeyEnter"
				class="rp-messenger-reply-input-utils-button">
                <SendIcon />
            </button>
        </div>
    </div>
</template>

<script>
import GifIcon from './GifIcon'
import ClipIcon from './ClipIcon'
import EmojiIcon from './EmojiIcon'
import SendIcon from './SendIcon'
import EmojisExplorer from '../EmojisExplorer/'

const MEDIA_TYPE_GIF = 'gif';
const MEDIA_TYPE_STICKER = 'sticker';
const MEDIA_TYPE_TEXT = 'text';
const MEDIA_TYPE_FILE = 'file';

const MAX_FILE_SIZE_IN_BYTES = 50 * 1024 * 1024;
const bytesToMB = bytes => bytes / (2**20);

export default {

	components: {
		GifIcon,
		ClipIcon,
		EmojiIcon,
		SendIcon,
		// GifsExplorer,
		EmojisExplorer
	},

    data() {
		return {
			text: '',
			isGIFPopoverVisible: false,
			isEmojisPopoverVisible: false
		}
    },

    mounted() {
		// this.$refs.textarea.focus();
	},

    watch: {

		text(val) {
			this.$emit('onTyping', val)
		},
		
	},
	
	computed: {

		isTextActive() {
			return !!this.text.trim()
		}

	},
    
    methods: {

		async handleFileChange(e) {
			const file = e.target.files[0];
			if (file) {
				const { size } = file;
				if (size > MAX_FILE_SIZE_IN_BYTES) {
					alert('File size should be less than 50mb');
					return;
				};
				this.$emit('onEnterNewMessage', { type: MEDIA_TYPE_FILE, value: file });
			}
		},

		// handleGIFItemClick({ url }) {
		// 	this.$emit('onEnterNewMessage', { type: MEDIA_TYPE_GIF, value: url });
		// 	this.isGIFPopoverVisible = false;
		// },

		handleEmojiItemClick(emoji) {
			if (this.isTextActive) {
				this.text += emoji;
				this.$refs.textarea.focus();
			} else {
				this.$emit('onEnterNewMessage', { type: MEDIA_TYPE_STICKER, value: emoji });
			}

			this.isEmojisPopoverVisible = false;
		},

        handleKeyEnter(e) {
			e.preventDefault()
			const { text } = this
			if (text.trim()) {
				this.$emit('onEnterNewMessage', { type: MEDIA_TYPE_TEXT, value: text });
				this.text = '';
			}
		},

		handleFileUploadClick() {
			this.$refs['fileUpload'].click();
		}
        
    }

}
</script>

<style lang="scss">

.rp-messenger-reply-input-box {
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;
	min-height: 56px;
	max-height: 200px;
	border-top: 1px solid #e6e6e6;
	z-index: 1;
	&.closed-conversation {
		padding: 14px 20px;
		bottom: 30px !important;
		border-top: 0px;
		background: #f5f5f5 !important;
		.hint-text {
			font-size: 13px;
			font-weight: 400;
			font-family:  $chatFont;
			padding-bottom: 14px;
		}
	}
	
	textarea {
		position: absolute;
		bottom: 0;
		left: 0;
		padding: 18px 100px 18px 29px;

		width: 100%;
		height: 100%;
		line-height: 1.33;
		background: #ffffff;
		white-space: pre-wrap;
		word-wrap: break-word;
		font-family: $font;
		font-size: 14px;
		font-weight: $fontWeight;
		transition: box-shadow .2s;
		color:#333333;
		@include for-size(tablet-landscape-up){
			border-bottom: 1px solid #E6E5E6;
			border-bottom-left-radius: 10px;
			border-bottom-right-radius: 10px;
			padding-right: 180px;
			font-size: 18px;
			line-height: 1;
		}
		&:focus {
			box-shadow: 0px 0px 100px 0px rgba(0, 0, 0, 0.1)
		}

		&::-webkit-input-placeholder { 
		  color: #999999;
		}
		&::-moz-placeholder { 
		  color: #999999;
		}
		&:-ms-input-placeholder { 
		  color: #999999;
		}
		&:-moz-placeholder { 
		  color: #999999;
		}
	}

	&[disabled="disabled"] {
		// opacity: .5;
		pointer-events: none;
		cursor: not-allowed;
	}
}

.rp-messenger-reply-input-utils {
	@include flexFullCenter;
	@include absoluteYCenter;

	right: 10px;
}

.rp-messenger-reply-input-utils-button {
	@include square(30px);
	@include for-size(desktop-up){
		@include square(50px);
	}
	display: block;
	cursor: pointer;
	margin: 0 4px;
	background: transparent;

	svg {
		fill: $darkGreyColor;
		@include for-size(desktop-up){
			@include square(30px);
		}
	}

	&.file-upload {
		input {
			opacity: 0;
			width: 0;
			height: 0;
			font-size: 0;
			text-indent: 100%;
		}
	}
}

.rp-gifs {
	height: 300px;
}

.rp-emojis {
	height: 300px;
}

.emoji-mart {
	width: auto;
}

</style>
